var _mask, _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 40,
    viewBox: "0 0 35 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4954 31.1086C27.2035 29.3856 32.1575 23.3407 32.1575 16.1482C32.1575 7.61379 25.1826 0.695312 16.5787 0.695312C7.97484 0.695312 1 7.61379 1 16.1482C1 23.3409 5.95429 29.3859 12.6626 31.1087L16.579 39.0605L20.4954 31.1086Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4954 31.1086C27.2035 29.3856 32.1575 23.3407 32.1575 16.1482C32.1575 7.61379 25.1826 0.695312 16.5787 0.695312C7.97484 0.695312 1 7.61379 1 16.1482C1 23.3409 5.95429 29.3859 12.6626 31.1087L16.579 39.0605L20.4954 31.1086Z",
    fill: "#011133"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4954 31.1086L20.4332 30.8664L20.3219 30.895L20.2711 30.9981L20.4954 31.1086ZM12.6626 31.1087L12.8869 30.9983L12.8361 30.8952L12.7248 30.8666L12.6626 31.1087ZM16.579 39.0605L16.3547 39.171L16.579 39.6264L16.8032 39.171L16.579 39.0605ZM31.9075 16.1482C31.9075 23.2226 27.0347 29.1708 20.4332 30.8664L20.5576 31.3507C27.3722 29.6003 32.4075 23.4589 32.4075 16.1482H31.9075ZM16.5787 0.945312C25.0465 0.945312 31.9075 7.75377 31.9075 16.1482H32.4075C32.4075 7.47381 25.3188 0.445312 16.5787 0.445312V0.945312ZM1.25 16.1482C1.25 7.75377 8.111 0.945312 16.5787 0.945312V0.445312C7.83869 0.445312 0.75 7.47381 0.75 16.1482H1.25ZM12.7248 30.8666C6.12308 29.1711 1.25 23.2228 1.25 16.1482H0.75C0.75 23.4591 5.78551 29.6007 12.6005 31.3509L12.7248 30.8666ZM16.8032 38.9501L12.8869 30.9983L12.4384 31.2192L16.3547 39.171L16.8032 38.9501ZM20.2711 30.9981L16.3547 38.9501L16.8032 39.171L20.7197 31.219L20.2711 30.9981Z",
    fill: "white",
    mask: "url(#path-1-inside-1)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.2118 16.0013C29.2118 22.9972 23.4932 28.6754 16.4304 28.6754C9.36754 28.6754 3.64893 22.9972 3.64893 16.0013C3.64893 9.00536 9.36754 3.32715 16.4304 3.32715C23.4932 3.32715 29.2118 9.00536 29.2118 16.0013Z",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.148926,
    y: 0.827148,
    width: 34.5629,
    height: 34.3482,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinup);
export default __webpack_public_path__ + "static/media/pinup.6ae59c4b759daae772ebf39dcb39c5a0.svg";
export { ForwardRef as ReactComponent };